import React from "react";

import styled from "styled-components";

import { useCategoryCardContext } from "Dashboard/DashboardCards/DashboardCards";
import FnrTypography from "FnrTypography";

const Description = () => {
  const { description } = useCategoryCardContext();

  if (!description) return null;
  return (
    <SFnrTypography
      type="copy"
      fontSize="sm"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

const SFnrTypography = styled(FnrTypography)`
  a {
    color: ${({ theme }) => theme.palette.text.textPrimary};
  }
  p {
    margin: 0;
  }
`;

export default Description;
